
import { Auth, Storage } from 'aws-amplify';
import { get } from 'lodash';
import { useEffect, useState } from 'react';

import { faPlus, faSpinner } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// Removed Upload, message imports
// Added CBUpload import
import { CBUpload } from '../../core/components/CBUpload';
import {
    CBButton,
    CBHeader
} from '../../core/components/cbd';


function beforeUpload(file) {
	const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
	if (!isJpgOrPng) {
		alert('You can only upload JPG/PNG file!'); // Replaced message.error
	}
	const isLt4M = file.size / 1024 / 1024 < 4;

	if (!isLt4M) {
		alert('Image must smaller than 4MB!'); // Replaced message.error
	}

	return isJpgOrPng && isLt4M;
}


const ImageDisplay = ({width, height, image}) => {
	return (<div style= {{
		width: `${width}px`,
		height: `${height}px`,
		overflow: 'hidden',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center'
	}}>
		<img 
			src={`${process.env.REACT_APP_IMAGE_CDN}/${image}`}
			width={`${width}px`}
			/>
	</div>);
}


const ScheduleImageUploadIndividual = ({ image, setImage, cognitoUsername, type }) => {

	const [loading, setLoading] = useState(false);

	const uploadImage = info => {
		const { onSuccess, onError, file, onProgress } = info;
		// alert(`Uploading ${type}`); // Replaced message.info with alert (optional)
		console.log(`Uploading ${type}`); // Or use console.log for less intrusive feedback
		setLoading(true);
		const { name, type: contentType } = file;
		const fileKey = `${cognitoUsername}/${type}Images/${name}`

		Storage.put(fileKey, file, {
			progressCallback: onProgress,
			contentType
		}).then(complete => {
			setImage(fileKey);
			setLoading(false);
			onSuccess(fileKey);
			// alert(`Upload ${type} complete`); // Replaced message.info (optional)
			console.log(`Upload ${type} complete`); // Or use console.log
		}).catch(err => {
			alert('upload failed.'); // Replaced message.error
			setLoading(false);
			onError({ err }); // Keep onError callback
		});
	}

	const handleChange = () => {
		return false;
	}
	const handleUpload = () => {
		//we're basically overriding everything and just uploading when the user selects
		return false;
	}

	const uploadButton = (
		<div>
			{loading ? <FontAwesomeIcon icon={faSpinner} spin={true} /> : <FontAwesomeIcon icon={faPlus} />}
			<div style={{ marginTop: 8 }}>Upload{loading && 'ing'}</div>
		</div>
	);


	// Define a handler for CBUpload's onChange
	const handleFileSelected = (fileList) => {
		if (fileList && fileList.length > 0) {
			const file = fileList[0].originFileObj; // Get the actual File object
			if (beforeUpload(file)) { // Run validation
				// Manually trigger the upload logic (previously in customRequest)
				uploadImage({
					file,
					onSuccess: (key) => console.log('Uploaded:', key), // Basic success log
					onError: (err) => console.error('Upload error:', err), // Basic error log
					onProgress: ({ percent }) => console.log(`Progress: ${percent}%`), // Basic progress log
				});
			}
		}
	};

	return (<>
		{/* Replaced Upload with CBUpload */}
		{/* Note: UI needs significant change as CBUpload is basic */}
		<CBUpload
			name={type}
			accept="image/*"
			onChange={handleFileSelected} // Use the new handler
			// Removed unsupported props: listType, showUploadList, customRequest, handleUpload, beforeUpload (handled in onChange)
			className={`${type}-uploader mb-2`} // Added margin
		>
			{/* CBUpload children act as the trigger */}
			<div className="border-2 border-dashed border-gray-300 rounded-md p-4 text-center cursor-pointer hover:border-blue-500">
				{loading ? (
					<FontAwesomeIcon icon={faSpinner} spin={true} />
				) : image ? (
					<ImageDisplay image={image} height={80} width={80} /> // Adjust size as needed
				) : (
					uploadButton // Use the existing uploadButton content
				)}
			</div>
		</CBUpload>
		<CBButton
			disabled={image == '' || image == null}
			onClick={(e) => {
				setImage('')
			}}
		>Remove Image</CBButton>
	</>);

}

const ScheduleImageUpload = ({ iconImage, avatarImage, setIconImage, setAvatarImage }) => {

	const [cognitoUsername, setCognitoUsername] = useState(null);
	useEffect(() => {
		Auth.currentUserInfo().then(session => {
			setCognitoUsername(get(session, "id"));
		});
	}, []);



	// Lets not even try to save an image if we don't know where to save it to
	// 
	if (!cognitoUsername) {
		return (<FontAwesomeIcon
			icon={faSpinner}
			size="3x"
			spin={true}
		/>);
	}


	return (<>
		<CBHeader
			label={'Upload A Banner Image (optional)'}
			level={3}
			style={{ textAlign: 'center', marginTop: 0, marginBottom: 20 }}
		></CBHeader>
		<ScheduleImageUploadIndividual
			image={iconImage}
			setImage={setIconImage}
			cognitoUsername={cognitoUsername}
			type={'icon'} />
		<CBHeader
			label={'Upload An Avatar Image (optional)'}
			level={3}
			style={{ textAlign: 'center', marginTop: 0, marginBottom: 20 }}
		></CBHeader>
		<ScheduleImageUploadIndividual
			image={avatarImage}
			setImage={setAvatarImage}
			cognitoUsername={cognitoUsername}
			type={'avatar'} />
	</>);
}

export default ScheduleImageUpload;